import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMediaUrl, variousURLs, arcademicsIntroDuration, mixpanelAbandonedMethods } from "../../config";
import ArcademicsHTML5 from "./arcademicsHTML5";
import { clickToPlayVideoSelector } from "../../redux/slices/preContentVideoSlice";
import ClickToPlayVideo from "../ads/ClickToPlayVideo";
import { useSearchParams } from "react-router";
import { getGameAnalytics, getGameHTMLVersion } from "../../utilities/games";
import { setInitialState, setGame as setAnalyticsGame } from "../../redux/slices/gameSlice";
import { useGameAbandonedHandler, useIframeSourceValidation } from "../../hooks";

export default function DesktopGame({ gameData, isArcademics }) {
  const dispatch = useDispatch();
  const gameAbandonedHandler = useGameAbandonedHandler();
  const clickToPlayVideo = useSelector(clickToPlayVideoSelector);
  const [searchParams] = useSearchParams();
  const gameVersionOverride = searchParams.get("gameVersion");

  const [game, setGame] = useState({});
  const iframeRef = useRef(null);

  useEffect(() => {
    if (game.shortname !== gameData.shortname) {
      setGame(gameData);
      dispatch(setAnalyticsGame(getGameAnalytics(gameData, false)));
    }

    return () => {
      dispatch(setInitialState());
    };
  }, [gameData]);

  useIframeSourceValidation(iframeRef, game?.shortname);

  const renderIframe = () => {
    if (!game.shortname) {
      return null;
    }

    const gameVisibilityStyle = clickToPlayVideo
      ? {
          opacity: 0,
          visibility: "hidden",
        }
      : null;

    return (
      <iframe
        ref={iframeRef}
        key={game.shortname}
        id="abcya-game-iframe"
        data-testid="abcya-game-iframe"
        title={game.shortname}
        style={gameVisibilityStyle}
        frameBorder="0"
        allow="accelerometer *;magnetometer *;gyroscope *;"
        src={`${getMediaUrl()}/games/${game.shortname}/${getGameHTMLVersion(game, gameVersionOverride)}/index.html`}
      />
    );
  };

  if (isArcademics) {
    return (
      <ArcademicsHTML5
        gameName={game.arcademicsName}
        settings={{
          introURL: variousURLs.arcademics.intro,
          introDuration: arcademicsIntroDuration,
          endGameEnabled: false,
          printEnabled: false,
        }}
      />
    );
  }

  return (
    <>
      {clickToPlayVideo && <ClickToPlayVideo />}
      {renderIframe()}
    </>
  );
}
